<template>
  <div>
    <site-filter
      siteListGetter="aiFactory/getSiteConnectors"
      itemValue="site.id"
      itemText="site.name"
      @valueChanged="updateSite"
      :noUrl="true"
      storeGetter="getSelectedSites"
      :multiple="false"
      :dependsOnSiteGroups="false"
    />
  </div>
</template>

<script>
import { computed, onMounted, reactive } from "@vue/composition-api";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import DateFilter from "@/components/common/filters/DateFilter.vue";
import SiteFilter from "@/components/common/filters/SiteFilter.vue";

export default {
  name: "Filters",
  components: {
    ApplyFilters,
    DateFilter,
    SiteFilter,
  },
  setup(props, { emit }) {
    const { store } = useProxy();
    const { isLoading } = useAxios();

    const config = reactive({
      isInitialized: false,
      site_id_out: 0,
    });

    // =>  METHODS
    const updateSite = (value) => {
      config.site_id_out = value;
      emit("valueChanged", value); // Émet l'événement avec la nouvelle valeur
    };

    // =>  COMPUTED
    const site = computed(() => {
      const value = store.getters["aiFactory/getSelectedSites"];

      return (isArray(value) && isEmpty(value)) || value === "" ? 0 : value;
    });

    const disableSearch = computed(() => {
      return (site.value ?? 0) === 0 || isLoading.value;
    });

    // =>  WATCH

    // =>  HOOKS
    onMounted(async () => {
      config.isInitialized = true;
    });

    // =>  DATA
    return {
      disableSearch,
      site,
      updateSite,
      config,
    };
  },
};
</script>

<style></style>
